// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Principal */
.productos-container {
    background-color: var(--app-fondo);
    color: var(--texto-principal);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    transition: background-color 0.3s ease;
}

.productos-main {
    padding: 32px;
    flex: 1 1;
    margin: 0px 80px; 
}

/* TOOLBAR */
.toolbar-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap; 
    gap: 20px;       
    margin-bottom: 25px;
    
    background: var(--bg-card); /* Variable */
    
    padding: 20px;
    border-radius: 12px;
    box-shadow: var(--sombra-card);
    border: 1px solid var(--color-borders);
}

.search-wrapper {
    position: relative;
    flex: 1 1;
    min-width: 280px;
}

.search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--color-gray-text);
    font-size: 1.2rem;
}

.search-input {
    width: 90%;
    padding: 10px 12px 10px 45px;
    border: 1px solid var(--color-borders); 
    background-color: var(--bg-input); /* Variable */
    color: var(--texto-principal);
    border-radius: 8px;
    font-size: 14px; 
    outline: none;
    transition: all 0.2s;
}

.search-input:focus {
    border-color: var(--primary-blue);
    box-shadow: 0 0 0 3px rgba(67, 56, 202, 0.1);
}

.filter-date-button-wrapper {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}

.filter-select {
    padding: 10px 12px;
    border: 1px solid var(--color-borders);
    border-radius: 8px;
    background-color: var(--bg-input);
    color: var(--texto-principal);
    cursor: pointer;
    outline: none;
    font-size: 14px;
}

.filter-select:focus {
    border-color: var(--primary-blue);
}

.btn-add-product {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    background-color: var(--primary-blue);
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-add-product:hover {
    opacity: 0.9;
    transform: translateY(-2px);
}

/* GRID */
.productos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 24px;
}

.producto-card {
    background: var(--bg-card);
    border-radius: 12px;
    padding: 24px;
    box-shadow: var(--sombra-card);
    transition: all 0.3s ease;
    border: 1px solid transparent; 
}

body.dark-mode .producto-card {
    border: 1px solid var(--color-borders);
}

.producto-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.25);
    border-color: var(--primary-blue);
}

.producto-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 15px;
    border-bottom: 2px solid var(--color-light-bg);
    margin-bottom: 15px;
}

.producto-icon-title {
    display: flex;
    align-items: center;
    gap: 12px;
    overflow: hidden;
    flex: 1 1;
}

.producto-icon {
    font-size: 2rem;
    color: var(--primary-blue);
    flex-shrink: 0;
}

.producto-nombre {
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--texto-principal);
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
}

.producto-actions {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
}

.btn-icon {
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 6px;
    color: var(--color-gray-text);
    transition: all 0.2s;
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-icon:hover {
    color: var(--primary-blue);
    background-color: var(--color-light-bg);
}

.btn-delete:hover {
    color: var(--score-rojo);
    background-color: rgba(239, 68, 68, 0.1);
}

.producto-info {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.95rem;
}

.info-label {
    color: var(--color-gray-text);
    font-weight: 500;
}

.info-value {
    font-weight: 600;
    color: var(--texto-principal);
    text-align: right;
}

.info-value.price {
    font-size: 1.1rem;
    color: var(--primary-blue);
}

.info-tag {
    background-color: rgba(80, 56, 237, 0.1);
    color: var(--primary-blue);
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 600;
    border: 1px solid rgba(80, 56, 237, 0.2);
}

.truncate {
    max-width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* SKELETON LOADING */
.skeleton-card { border: 1px solid var(--color-borders); }
.skeleton-circle { width: 45px; height: 45px; background-color: var(--color-light-bg); border-radius: 50%; animation: pulse 1.5s infinite; }
.skeleton-title { height: 24px; width: 60%; background-color: var(--color-light-bg); border-radius: 6px; animation: pulse 1.5s infinite; }
.skeleton-line { height: 16px; width: 100%; background-color: var(--color-light-bg); border-radius: 4px; animation: pulse 1.5s infinite; }
.skeleton-line.short { width: 40%; align-self: flex-end; }
@keyframes pulse { 0% { opacity: 0.6; } 50% { opacity: 1; } 100% { opacity: 0.6; } }

/* PAGINACION */
.paginacion {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid var(--color-borders);
}

.paginacion p {
    font-size: 14px;
    color: var(--color-gray-text);
    margin: 0;
}

.paginacion-botones {
    display: flex;
    gap: 6px;
}

.paginacion-botones button {
    padding: 6px 12px;
    border-radius: 6px;
    border: 1px solid var(--color-borders);
    background: var(--bg-card);
    cursor: pointer;
    transition: background .2s;
    color: var(--texto-principal);
    font-size: 14px;
}

.paginacion-botones button:hover:not(:disabled) {
    background: var(--color-light-bg);
}

.paginacion-botones .activo {
    background-color: var(--primary-blue);
    color: white;
    border-color: var(--primary-blue);
}

.paginacion-botones button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.empty-state {
    grid-column: 1 / -1;
    text-align: center;
    padding: 60px;
    background: var(--bg-card);
    border-radius: 12px;
    box-shadow: var(--sombra-card);
    border: 1px solid var(--color-borders);
}

.empty-state-icon { font-size: 4rem; margin-bottom: 15px; display: block; }
.empty-state-text { color: var(--color-gray-text); font-size: 1.2rem; font-weight: 500; }


@media (max-width: 768px) {
    .toolbar-container {
        flex-direction: column;
        align-items: stretch;
    }
    
    .filters-wrapper {
        flex-direction: column;
    }

    .search-wrapper {
        min-width: 100%;
    }

    .btn-add-product {
        justify-content: center;
    }

    .fixed-return-button {
        bottom: 20px;
        right: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Productos/productos.css"],"names":[],"mappings":"AAAA,cAAc;AACd;IACI,kCAAkC;IAClC,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,SAAO;IACP,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,mBAAmB;;IAEnB,0BAA0B,EAAE,aAAa;;IAEzC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B,sCAAsC;IACtC,iCAAiC,EAAE,aAAa;IAChD,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,iCAAiC;IACjC,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,kBAAkB;IAClB,iCAAiC;IACjC,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,qCAAqC;IACrC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,2BAA2B;AAC/B;;AAEA,SAAS;AACT;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;IACxC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,uCAAuC;AAC3C;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,wCAAwC;IACxC,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,qBAAqB;AACrB,iBAAiB,sCAAsC,EAAE;AACzD,mBAAmB,WAAW,EAAE,YAAY,EAAE,uCAAuC,EAAE,kBAAkB,EAAE,8BAA8B,EAAE;AAC3I,kBAAkB,YAAY,EAAE,UAAU,EAAE,uCAAuC,EAAE,kBAAkB,EAAE,8BAA8B,EAAE;AACzI,iBAAiB,YAAY,EAAE,WAAW,EAAE,uCAAuC,EAAE,kBAAkB,EAAE,8BAA8B,EAAE;AACzI,uBAAuB,UAAU,EAAE,oBAAoB,EAAE;AACzD,mBAAmB,KAAK,YAAY,EAAE,EAAE,MAAM,UAAU,EAAE,EAAE,OAAO,YAAY,EAAE,EAAE;;AAEnF,eAAe;AACf;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;IACtC,0BAA0B;IAC1B,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,0BAA0B;IAC1B,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA,oBAAoB,eAAe,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC1E,oBAAoB,6BAA6B,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;;AAGxF;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;AACJ","sourcesContent":["/* Principal */\r\n.productos-container {\r\n    background-color: var(--app-fondo);\r\n    color: var(--texto-principal);\r\n    min-height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n.productos-main {\r\n    padding: 32px;\r\n    flex: 1;\r\n    margin: 0px 80px; \r\n}\r\n\r\n/* TOOLBAR */\r\n.toolbar-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    flex-wrap: wrap; \r\n    gap: 20px;       \r\n    margin-bottom: 25px;\r\n    \r\n    background: var(--bg-card); /* Variable */\r\n    \r\n    padding: 20px;\r\n    border-radius: 12px;\r\n    box-shadow: var(--sombra-card);\r\n    border: 1px solid var(--color-borders);\r\n}\r\n\r\n.search-wrapper {\r\n    position: relative;\r\n    flex: 1;\r\n    min-width: 280px;\r\n}\r\n\r\n.search-icon {\r\n    position: absolute;\r\n    left: 12px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    color: var(--color-gray-text);\r\n    font-size: 1.2rem;\r\n}\r\n\r\n.search-input {\r\n    width: 90%;\r\n    padding: 10px 12px 10px 45px;\r\n    border: 1px solid var(--color-borders); \r\n    background-color: var(--bg-input); /* Variable */\r\n    color: var(--texto-principal);\r\n    border-radius: 8px;\r\n    font-size: 14px; \r\n    outline: none;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.search-input:focus {\r\n    border-color: var(--primary-blue);\r\n    box-shadow: 0 0 0 3px rgba(67, 56, 202, 0.1);\r\n}\r\n\r\n.filter-date-button-wrapper {\r\n    display: flex;\r\n    gap: 20px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.filter-select {\r\n    padding: 10px 12px;\r\n    border: 1px solid var(--color-borders);\r\n    border-radius: 8px;\r\n    background-color: var(--bg-input);\r\n    color: var(--texto-principal);\r\n    cursor: pointer;\r\n    outline: none;\r\n    font-size: 14px;\r\n}\r\n\r\n.filter-select:focus {\r\n    border-color: var(--primary-blue);\r\n}\r\n\r\n.btn-add-product {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    padding: 10px 20px;\r\n    background-color: var(--primary-blue);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.btn-add-product:hover {\r\n    opacity: 0.9;\r\n    transform: translateY(-2px);\r\n}\r\n\r\n/* GRID */\r\n.productos-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\r\n    gap: 24px;\r\n}\r\n\r\n.producto-card {\r\n    background: var(--bg-card);\r\n    border-radius: 12px;\r\n    padding: 24px;\r\n    box-shadow: var(--sombra-card);\r\n    transition: all 0.3s ease;\r\n    border: 1px solid transparent; \r\n}\r\n\r\nbody.dark-mode .producto-card {\r\n    border: 1px solid var(--color-borders);\r\n}\r\n\r\n.producto-card:hover {\r\n    transform: translateY(-4px);\r\n    box-shadow: 0 10px 20px rgba(0,0,0,0.25);\r\n    border-color: var(--primary-blue);\r\n}\r\n\r\n.producto-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding-bottom: 15px;\r\n    border-bottom: 2px solid var(--color-light-bg);\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.producto-icon-title {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    overflow: hidden;\r\n    flex: 1;\r\n}\r\n\r\n.producto-icon {\r\n    font-size: 2rem;\r\n    color: var(--primary-blue);\r\n    flex-shrink: 0;\r\n}\r\n\r\n.producto-nombre {\r\n    font-size: 1.2rem;\r\n    font-weight: 600;\r\n    color: var(--texto-principal);\r\n    margin: 0;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    line-height: 1.2;\r\n}\r\n\r\n.producto-actions {\r\n    display: flex;\r\n    gap: 6px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.btn-icon {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 8px;\r\n    border-radius: 6px;\r\n    color: var(--color-gray-text);\r\n    transition: all 0.2s;\r\n    font-size: 1.2rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.btn-icon:hover {\r\n    color: var(--primary-blue);\r\n    background-color: var(--color-light-bg);\r\n}\r\n\r\n.btn-delete:hover {\r\n    color: var(--score-rojo);\r\n    background-color: rgba(239, 68, 68, 0.1);\r\n}\r\n\r\n.producto-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n}\r\n\r\n.info-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    font-size: 0.95rem;\r\n}\r\n\r\n.info-label {\r\n    color: var(--color-gray-text);\r\n    font-weight: 500;\r\n}\r\n\r\n.info-value {\r\n    font-weight: 600;\r\n    color: var(--texto-principal);\r\n    text-align: right;\r\n}\r\n\r\n.info-value.price {\r\n    font-size: 1.1rem;\r\n    color: var(--primary-blue);\r\n}\r\n\r\n.info-tag {\r\n    background-color: rgba(80, 56, 237, 0.1);\r\n    color: var(--primary-blue);\r\n    padding: 3px 10px;\r\n    border-radius: 20px;\r\n    font-size: 0.85rem;\r\n    font-weight: 600;\r\n    border: 1px solid rgba(80, 56, 237, 0.2);\r\n}\r\n\r\n.truncate {\r\n    max-width: 180px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n/* SKELETON LOADING */\r\n.skeleton-card { border: 1px solid var(--color-borders); }\r\n.skeleton-circle { width: 45px; height: 45px; background-color: var(--color-light-bg); border-radius: 50%; animation: pulse 1.5s infinite; }\r\n.skeleton-title { height: 24px; width: 60%; background-color: var(--color-light-bg); border-radius: 6px; animation: pulse 1.5s infinite; }\r\n.skeleton-line { height: 16px; width: 100%; background-color: var(--color-light-bg); border-radius: 4px; animation: pulse 1.5s infinite; }\r\n.skeleton-line.short { width: 40%; align-self: flex-end; }\r\n@keyframes pulse { 0% { opacity: 0.6; } 50% { opacity: 1; } 100% { opacity: 0.6; } }\r\n\r\n/* PAGINACION */\r\n.paginacion {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-top: 30px;\r\n    padding-top: 20px;\r\n    border-top: 1px solid var(--color-borders);\r\n}\r\n\r\n.paginacion p {\r\n    font-size: 14px;\r\n    color: var(--color-gray-text);\r\n    margin: 0;\r\n}\r\n\r\n.paginacion-botones {\r\n    display: flex;\r\n    gap: 6px;\r\n}\r\n\r\n.paginacion-botones button {\r\n    padding: 6px 12px;\r\n    border-radius: 6px;\r\n    border: 1px solid var(--color-borders);\r\n    background: var(--bg-card);\r\n    cursor: pointer;\r\n    transition: background .2s;\r\n    color: var(--texto-principal);\r\n    font-size: 14px;\r\n}\r\n\r\n.paginacion-botones button:hover:not(:disabled) {\r\n    background: var(--color-light-bg);\r\n}\r\n\r\n.paginacion-botones .activo {\r\n    background-color: var(--primary-blue);\r\n    color: white;\r\n    border-color: var(--primary-blue);\r\n}\r\n\r\n.paginacion-botones button:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.empty-state {\r\n    grid-column: 1 / -1;\r\n    text-align: center;\r\n    padding: 60px;\r\n    background: var(--bg-card);\r\n    border-radius: 12px;\r\n    box-shadow: var(--sombra-card);\r\n    border: 1px solid var(--color-borders);\r\n}\r\n\r\n.empty-state-icon { font-size: 4rem; margin-bottom: 15px; display: block; }\r\n.empty-state-text { color: var(--color-gray-text); font-size: 1.2rem; font-weight: 500; }\r\n\r\n\r\n@media (max-width: 768px) {\r\n    .toolbar-container {\r\n        flex-direction: column;\r\n        align-items: stretch;\r\n    }\r\n    \r\n    .filters-wrapper {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .search-wrapper {\r\n        min-width: 100%;\r\n    }\r\n\r\n    .btn-add-product {\r\n        justify-content: center;\r\n    }\r\n\r\n    .fixed-return-button {\r\n        bottom: 20px;\r\n        right: 20px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
